<!--
  Three states in one dialog: picking a file, waiting, and reading what came back.
  The dialog does not close between them, so fixing a spreadsheet and trying again
  never sends the user back to the UPLOAD button.
-->
<div class="py-7 px-6 max-w-[90vw] flex flex-col">

  <!-- Picking ------------------------------------------------------------->
  <ng-container *ngIf="state === 'picking'">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-1 text-center">Upload Results</p>
    <p class="text-sm text-[var(--tertiary-text)] mb-5 text-center">Replace the current attached file.</p>

    <!-- Kept visible while choosing the corrected file, so the user can still read
         what was wrong with the last one. -->
    <div *ngIf="problems.length" class="w-full mb-4">
      <p class="text-[13px] font-semibold text-[var(--base-text-alt-dark)] m-0 mb-2">What was wrong last time</p>
      <app-results-problem-list [problems]="problems" [problemsOmitted]="problemsOmitted"></app-results-problem-list>
    </div>

    <div *ngIf="errorMessage" class="upload-error rounded-lg p-3 mb-4 text-[13px]">{{errorMessage}}</div>

    <div class="bg-[var(--app-base)] rounded-lg px-4 py-4 mb-4 flex flex-col items-center gap-3 w-full">
      <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="visibility: hidden; position: absolute;" (change)="handleFileInput($event.target.files)" #fileinput />

      <button (click)="openFileInput()" type="button"
        class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
        <span class="material-icons text-[16px]">attach_file</span> ATTACH FILE
      </button>

      <div *ngIf="fileName" class="flex items-center text-[12px]">
        <span class="font-bold text-[var(--base-text-alt-dark)] mr-1.5">File Name:</span>
        <span class="text-[var(--tertiary-text)]">{{fileName.length > 20 ? (fileName | slice: 0 : 20) + '...' : fileName}}</span>
      </div>
    </div>

    <div class="flex justify-center gap-3 mt-2 w-full">
      <button (click)="cancel()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
      <button [disabled]="!fileToUpload" (click)="upload()"
        class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition disabled:bg-[#E6E6E6] disabled:text-[#C3C3C3]">Upload</button>
    </div>
  </ng-container>

  <!-- Uploading ----------------------------------------------------------->
  <div *ngIf="state === 'uploading'" class="flex flex-col items-center gap-4 py-8">
    <mat-spinner diameter="36"></mat-spinner>
    <p class="text-[13px] text-[var(--tertiary-text)] m-0">Checking the file...</p>
  </div>

  <!-- What came back ------------------------------------------------------>
  <ng-container *ngIf="state === 'problems'">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-2">
      {{ isBlocking ? 'This file was not uploaded' : 'Results uploaded with warnings' }}
    </p>
    <p class="text-[13px] text-[var(--base-text-alt-dark)] m-0 mb-5">{{summary}}</p>

    <app-results-problem-list [problems]="problems" [problemsOmitted]="problemsOmitted"></app-results-problem-list>

    <div class="flex justify-end gap-3 mt-6">
      <button (click)="cancel()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Close</button>

      <!-- The reason this dialog exists. Available for both verdicts: a warning file
           stored, but the user may still want to correct and replace it. -->
      <button (click)="chooseAnotherFile()"
        class="px-5 py-2.5 rounded-lg text-[13px] font-medium border border-[var(--primary-dark)] text-[var(--primary-dark)] hover:bg-[var(--app-base)] transition">
        Upload a different file
      </button>

      <!-- Nothing was stored when blocking, so there is nothing to continue with. -->
      <button *ngIf="!isBlocking" (click)="finish()"
        class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">
        Continue
      </button>
    </div>
  </ng-container>
</div>
